import { DocumentAddedBy, IDocumentTable } from '@models/Document.model';
import { ReactComponent as UserBeam } from '@assets/svg/userbeam.svg';
import { ReactComponent as AvatarPlaceholder } from '@assets/svg/avatar-placeholder.svg';
import { ProfileImg } from '../components/DocumentsBody/DocumentsBody.styles';

export function getAddedByIcon(document: IDocumentTable) {
  if (document.addedBy === DocumentAddedBy.beam) {
    return <UserBeam />;
  }

  return (
    <ProfileImg
      src={document.addedByUser?.picture}
      withPlaceholder
      width={16}
      height={16}
      placeholder={<AvatarPlaceholder height={16} width={16} />}
    />
  );
}
